import React from "react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export default function HeaderTask({ workerColor, error, titleModal, taskName, handleClose }) {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "18px",
        }}>
            <h1
                style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <span
                    title="Color del trabajador"
                    style={{
                        display: "inline-block",
                        width: "8px",
                        height: "28px",
                        backgroundColor: workerColor ? `#${workerColor}` : "#333",
                        marginRight: "12px",
                        borderRadius: "3px",
                    }}
                ></span>
                {error ? (
                    <span style={{ color: "#d32f2f" }}>ERROR</span>
                ) : (
                    <>
                        {titleModal}
                        {taskName && (
                            <span
                                style={{
                                    marginLeft: 8,
                                    color: workerColor ? `#${workerColor}` : "#333",
                                    fontWeight: 700,
                                    textShadow: "0 1px 2px #fff"
                                }}
                            >
                                {taskName}
                            </span>
                        )}
                    </>
                )}
            </h1>
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close" sx={{ ml: 2 }}>
                <CloseIcon />
            </IconButton>
        </div>
    );
}
